import React from "react";
import HomePage from "../pages/home";
import SdkCheckout from "../pages/sdk-checkout";
import CreatePaymentLink from "../pages/create-payment-link";
import CreatePaymentLinkWithQr from "../pages/create-payment-link-with-qr";
import CreateSuperPaymentLink from "../pages/create-super-payment-link";
import SdkStripePaymentLink from "../pages/sdk-stripe-payment-link";
import SdkShopifyPaymentLink from "../pages/sdk-shopify-payment-link";
import SdkRazorpayPaymentLink from "../pages/sdk-razorpay-payment-link";
import SdkXnditPaymentLink from "../pages/sdk-xendit-payment-link";
import SdkReddotPaymentLink from "../pages/sdk-reddot-payment-link";
import SdkSquarePaymentLink from "../pages/sdk-square-payment-link";
import SdkPayUPaymentLink from "../pages/sdk-payu-payment-link";
import SdkAdyenPaymentLink from "../pages/sdk-adyen-payment-link";
import SdkAirwallexPaymentLink from "../pages/sdk-airwallex-payment-link";
import SdkTyroPaymentLink from "../pages/sdk-tyro-payment-link";
import SdkNetsPaymentLink from "../pages/sdk-nets-payment-link";

const routes = [
  {
    path: "/",
    element: <HomePage />,
    exact: true,
    title: "Home",
    showInSideNav: false
  },
  {
    path: "/:shop/pay",
    element: <CreatePaymentLink />,
    exact: true,
    title: "Create payment link",
    showInSideNav: false
  },
  {
    path: "/:shop/pay-qr",
    element: <CreatePaymentLinkWithQr />,
    exact: true,
    title: "Create payment link",
    showInSideNav: false
  },
  {
    path: "/:shop/superpay",
    element: <CreateSuperPaymentLink />,
    exact: true,
    title: "Create super payment link",
    showInSideNav: false
  },
  {
    path: "/checkout/:id",
    element: <SdkCheckout />,
    exact: true,
    title: "Checkout",
    showInSideNav: false
  },
  {
    path: "/str/:id",
    element: <SdkStripePaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/spf/:id",
    element: <SdkShopifyPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/rzp/:id",
    element: <SdkRazorpayPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/xnd/:id",
    element: <SdkXnditPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/rdp/:id",
    element: <SdkReddotPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/sqr/:id",
    element: <SdkSquarePaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/pyu/:id",
    element: <SdkPayUPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/adn/:id",
    element: <SdkAdyenPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/awx/:id",
    element: <SdkAirwallexPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/tyr/:id",
    element: <SdkTyroPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  },
  {
    path: "/nts/:id",
    element: <SdkNetsPaymentLink />,
    exact: true,
    title: "Payment",
    showInSideNav: false
  }
];

export default routes;
